// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"_3vd8Y","title":"_2_jfe","description":"_2bKGz","buttons":"_3BZPZ"};